import { setToggleAccordion } from "./horoscope_range.js"

document.addEventListener("turbo:load", function () {
  if (document.getElementById("profile-info") != null) {
    const usageDates = document.querySelectorAll(".usage-date")
    usageDates.forEach((d) => {
      const formattedDate = new Date(d.textContent).toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
      d.textContent = formattedDate
    })
  }

  if (document.getElementById("mini-contents") != null) {
    const shortCards = document.querySelectorAll(".short-card")
    shortCards.forEach(card => {
      const btn = card.querySelector("button.read-more")
      const cardBody = card.querySelector(".body")

      if (btn) {
        btn.addEventListener("click", () => {
          btn.classList.toggle("expand")
          cardBody.classList.toggle("expand")
        })
      }
    })
  }
})

document.addEventListener("turbo:frame-load", function() {
  let page = document.getElementById("horoscope-range")
  if (page != null) {
    setToggleAccordion(page)
  }
})
